import React from "react";
import { Link } from "react-router-dom";
import ofgemImage from "../../assets/images/compliance-ofgem.jpg";
import euImage from "../../assets/images/compliance-eu.jpg";
import carbonImage from "../../assets/images/compliance-carbon.jpg";
import Reveal from "../Reveal/Reveal";
import { IconCheckCircle } from "../Icons/Icons";
import "../../assets/css/compliance.css";

const DETAILS = [
  {
    id: "ofgem",
    index: "01",
    eyebrow: "Regulatory Compliance",
    title: "Ofgem and Regulatory Compliance",
    image: ofgemImage,
    alt: "Electricity transmission tower on a grass field, representing UK grid regulation",
    text: "Meeting Ofgem's regulatory requirements can be time-consuming and complex. Our experienced consultants provide end-to-end support, from pre-accreditation through to ongoing compliance, so you can focus on running your business.",
    highlights: [
      "Pre-accreditation through to ongoing compliance",
      "Navigating GGSS and RHI schemes",
      "GHG calculations, reporting and audit preparation",
    ],
  },
  {
    id: "eu-red",
    index: "02",
    eyebrow: "International Certification",
    title: "EU Renewable Energy Directive",
    image: euImage,
    alt: "European Union flag flying, representing the EU Renewable Energy Directive",
    text: "Navigating the EU Renewable Energy Directive can be complex, but our experts make compliance straightforward, whether you are producing, trading or using renewable fuels.",
    highlights: [
      "ISCC EU certification and GHG calculations",
      "DENA registration and Nabisy administration",
      "Maintains market access, reduces admin burden",
    ],
  },
  {
    id: "carbon",
    index: "03",
    eyebrow: "Carbon & ESG Reporting",
    title: "Sustainability and Carbon Reporting",
    image: carbonImage,
    alt: "Sustainability and carbon reporting dashboard displayed on a laptop screen",
    text: "Robust sustainability reporting is essential for demonstrating compliance, meeting stakeholder expectations and supporting net zero ambitions.",
    highlights: [
      "GHG calculations and carbon reporting",
      "Audit-ready sustainability assessments",
      "Ongoing support or independent technical review",
    ],
  },
];

function Compliance() {
  return (
    <section className="section section-white" id="compliance">
      <div className="container">
        <div className="section-header">
          <Reveal direction="up">
            <span className="section-label">Detailed Consultancy Services</span>
            <h2 className="section-title">
              Compliance, Certification &amp; Reporting
            </h2>
            <p className="section-subtitle">
              In-depth support across the three pillars of regulatory and
              sustainability compliance for renewable energy businesses.
            </p>
          </Reveal>
        </div>

        {DETAILS.map((item, i) => (
          <div
            id={item.id}
            className={`split-layout compliance-item ${i % 2 === 1 ? "reverse" : ""}`}
            key={item.title}
          >
            <Reveal
              direction={i % 2 === 1 ? "right" : "left"}
              className="split-image"
            >
              <div className="compliance-image-wrap">
                <img src={item.image} alt={item.alt} />
                <span className="compliance-index">{item.index}</span>
              </div>
            </Reveal>

            <Reveal
              direction={i % 2 === 1 ? "left" : "right"}
              className="split-content"
            >
              <div className="compliance-content-panel">
                <span className="compliance-eyebrow">{item.eyebrow}</span>
                <h3 className="compliance-title">{item.title}</h3>
                <p className="compliance-text">{item.text}</p>
                <ul className="mini-feature-list compliance-highlights">
                  {item.highlights.map((point) => (
                    <li className="mini-feature-item" key={point}>
                      <IconCheckCircle
                        className="icon-check"
                        width={18}
                        height={18}
                      />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-primary compliance-cta">
                  Enquire Now
                </Link>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Compliance;
